import { DataList, DataItem } from '@cad-arc';
import { useEventMetadataStore } from '../../../../event-panel-form/event-metadata';
import { observer } from 'mobx-react-lite';
import { formatEventFormStringValue } from '../../../../format-event-form-string-value';
import { formatMonthDayYearHoursMinutes } from '../../../../../common/helpers/utils';

export const ScheduledEventDetailsSectionContent = observer(function ScheduledEventDetailsSection({
    receivedDateUtc,
}: {
    receivedDateUtc?: string;
}): React.ReactElement {
    const {
        agencyEventNumber,
        scheduledEventScheduledDateUtc,
        scheduledEventScheduledEndDateUtc,
        scheduledEventActivationBufferInMinutes,
        scheduledEventFrequencyType,
    } = useEventMetadataStore().state.metadata ?? {};

    return (
        <DataList>
            <DataItem dataKey="Scheduled Event #">{agencyEventNumber}</DataItem>
            <DataItem dataKey="Target On Scene Date/Time">
                {formatEventFormStringValue(
                    scheduledEventScheduledDateUtc,
                    formatMonthDayYearHoursMinutes
                )}
            </DataItem>
            <DataList direction="row">
                <DataItem dataKey="Buffer Activation Time">
                    {scheduledEventActivationBufferInMinutes !== undefined
                        ? `${scheduledEventActivationBufferInMinutes} minutes`
                        : undefined}
                </DataItem>
                <DataItem dataKey="Frequency">{scheduledEventFrequencyType}</DataItem>
            </DataList>
            <DataItem dataKey="End Date/Time">
                {formatEventFormStringValue(
                    scheduledEventScheduledEndDateUtc,
                    formatMonthDayYearHoursMinutes
                )}
            </DataItem>
            <DataItem dataKey="Recv">
                {formatEventFormStringValue(receivedDateUtc, formatMonthDayYearHoursMinutes)}
            </DataItem>
        </DataList>
    );
});
